const DownloadLink = ({ file, children, ...props }) => {
  const handleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <a href={file} onClick={handleClick} {...props} download={file}>
      {children}
    </a>
  );
};

export default DownloadLink;
